module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Medium.woff?5ce3e4db9634913232403f166b2447de";